import BotState from "../data/state/BotState";

// Update state of the bot, variables
// Param BotId, Id company of the block, Block to boot the bot, List of errors
function BotReducer(state, action) {
    
    switch (action.type) {
        case 'setInfo': {
            var variables = [...action.payload.variables];
            variables = variables.sort((a,b) => a.name.localeCompare(b.name))
            return {
                ...state,
                variables : [...variables],
                botId : action.payload.id,
                botName : action.payload.name,
                companyId : action.payload.company_id,
                blockStart : action.payload.block_start,
                phone: action.payload.phone,
                code: action.payload.code
            };
        }

        case 'onUpdate' : {

            return {
                ...state,
                onUpdate : action.payload.onUpdate
            };
        }

        case 'setErrors' : {

            return {
                ...state,
                errors : action.payload.errors
            };
        }

        case 'addError' : {
            return {
                ...state,
                errors : [...state.errors ,action.payload.error]
            };
        }

        case 'addVariable' : {

            var variables = [...state.variables, action.payload.variable];
            variables = variables.sort((a,b) => a.name.localeCompare(b.name))

            return {
                ...state,
                variables : [ ...variables ]
            };
        }

        case 'deleteVariable' : {
            return {
                ...state,
                variables : state.variables.filter( variable => variable.id != action.payload.id)
            };
        }

        case 'resetState' : {
            return BotState
        }

        default: {
            throw new Error('unhandled action');
        }
    
    }
}

export default BotReducer;